module.exports = __webpack_public_path__ + "lightimg-project.df586f10f77f05455e8bf4ded66ac665.hashedasset.svg";